import React, { useState } from "react";
import { Form, Button, Modal } from "antd";
import { gql, useMutation } from "@apollo/client";
import ClassInputs from "../inputs/class";

const CRERATEPRODUCT = gql`
  mutation createClass($createClassInput: CreateClassInput!) {
    createClass(createClassInput: $createClassInput) {
      id
      name
    }
  }
`;
function AddClass() {
  const [error, setError] = useState(null);
  const [form] = Form.useForm();
  const [runCreateProduct, createProduct] = useMutation(CRERATEPRODUCT, {
    onCompleted({ createClass }) {
      Modal.success({
        content: `${createClass?.name} به خدمات صفاتک اضافه شد.`,
        bodyStyle: { direction: "rtl" },
        okText: "باشه",
        onOk: () => form.resetFields(),
      });
    },
    onError(err) {
      console.log("خطا: " + err.message);
      Modal.error({
        title: "مشکلی پیش آمده!",
        content: "لطفا دوباره تلاش کنید!",
        bodyStyle: { direction: "rtl" },
        okText: "باشه",
      });
    },
  });
  const doCreateProduct = (createClassInput) => {
    runCreateProduct({
      variables: {
        createClassInput,
      },
    });
  };

  return (
    <>
      <Form layout="vertical" onFinish={doCreateProduct} form={form}>
       <ClassInputs error={error}/>
        <Button
          type="primary"
          htmlType="submit"
          loading={createProduct.loading && true}
        >
          ثبت خدمت
        </Button>
      </Form>
    </>
  );
}

export default AddClass;
